export default "__VITE_ASSET__WMmxwxCd__"